import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
export var StyledModalHeader = styled("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: start;\n    justify-content: space-between;\n    flex: 0 0 auto;\n    transition: box-shadow 200ms;\n"])));
//# sourceMappingURL=Header.js.map